export default "__VITE_ASSET__CuOKSYJF__"